//frontend/src/components/SearchManagerRequests/constants.jsx

import React from "react";

export const STATUS_LABELS = {
  sent: "Отправлено",
  in_progress: "В работе",
  done: "Готово",
};

export const STATUS_TONE = {
  sent: "new",
  in_progress: "searching",
  done: "completed",
};

export const STATUS_OPTIONS = [
  { value: "all", label: "Все статусы" },
  { value: "sent", label: "Отправлено" },
  { value: "in_progress", label: "В работе" },
  { value: "done", label: "Готово" },
];

export const EDITABLE_STATUS_OPTIONS = STATUS_OPTIONS.filter(
  (o) => o.value !== "all"
);

export function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status || "—";
  const tone = STATUS_TONE[status] || "new";
  return <span className={`proc-status proc-status--${tone}`}>{label}</span>;
}

export function Modal({ title, onClose, children, width = 560 }) {
  return (
    <div className="proc-modal__backdrop" onClick={onClose}>
      <div
        className="proc-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ width }}
      >
        {title && <h2 className="proc-modal__title">{title}</h2>}
        {children}
      </div>
    </div>
  );
}

export function normalizeGroups(user) {
  const g = user?.groups || [];
  return g.map((x) => (typeof x === "string" ? x : x.name));
}

export function isAdmin(user) {
  if (!user) return false;
  if (user.is_superuser) return true;
  return normalizeGroups(user).includes("administrators");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("ru-RU");
}

export function fmtDateOnly(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("ru-RU");
}

export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate()
  )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}